import React from 'react';
import {
  BrowserRouter ,
  Route,
  Routes,
} from "react-router-dom";
import PageLayout from "./Layout/PageLayout";
import Home from './Home/Index';
import DetailLook from './Home/DetailLook';
import Delegation from './Home/Delegation/Index.js';
import About from './About/Index';
import ProductIntro from './ProductIntro/Index.js';
import AiInventoryErp from './ProductIntro/AiInventoryErpIndex.js';
import SuccessCase from './SuccessCase/Index.js';
import HRTraining from './HRTraining/Index.js';
import ContactUs from './ContactUs/Index.js';
import HomeSuccessCase from './Home/SuccessCase/Index';
import CssBaseline from '@mui/material/CssBaseline';
import CustomHelmet from './CustomHelmet';
import theme from './theme';
import ThemeProvider from '@mui/styles/ThemeProvider';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CustomHelmet/>
      <CssBaseline enableColorScheme/>
      <BrowserRouter>
      <Routes>
        <Route element={<PageLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/DetailLook" element={<DetailLook/>}/>
            <Route path="/about" element={<About />} />
            <Route path="/HomeSuccessCase" element={<HomeSuccessCase/>}/>
            <Route path="/Delegation" element={<Delegation/>}/>
            <Route path="/ProductIntro" element={<ProductIntro/>}/>
            <Route path="/ai-inventory" element={<AiInventoryErp/>}/>
            <Route path="/SuccessCase" element={<SuccessCase/>}/>
            <Route path="/successcase" element={<SuccessCase/>}/>
            <Route path="/ContactUs" element={<ContactUs/>}/>
            <Route path="/HRTraining" element={<HRTraining/>}/>
        </Route>
      </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
